import React from 'react'
import { LayoutBand, Separator } from '@fs/zion-ui'
import NotesCardSkeleton from '../person-page/cards/notes-card/NotesCardSkeleton'
import DiscussionsCardSkeleton from '../person-page/cards/discussions-card/DiscussionsCardSkeleton'
import { PersonBandSkeleton } from '../research-help/ResearchHelpPageSkeleton'

export default function NotesPageSkeleton(): JSX.Element {
  return (
    <>
      <PersonBandSkeleton />

      <LayoutBand maxWidth="lg" marginY="sm">
        <NotesCardSkeleton />
        <Separator size="sm" />
        <DiscussionsCardSkeleton />
      </LayoutBand>
    </>
  )
}
